"use client";

import { FaMagnifyingGlass } from "react-icons/fa6";
import CustomDropdown, { DropdownOption } from "./CustomDropdown";
import { cn } from "@/lib/utils";

export interface CategorySearchFilterProps {
  options: DropdownOption[];
  selectedValue: string;
  onCategoryChange: (value: string) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  placeholder?: string;
  searchPlaceholder?: string;
  dropdownAriaLabel?: string;
  className?: string;
  dropdownClassName?: string;
  searchClassName?: string;
}

export default function CategorySearchFilter({
  options,
  selectedValue,
  onCategoryChange,
  searchQuery,
  onSearchChange,
  placeholder = "Categories",
  searchPlaceholder = "Search",
  dropdownAriaLabel = "Filter by category",
  className,
  dropdownClassName,
  searchClassName,
}: CategorySearchFilterProps) {
  return (
    <div
      className={cn(
        "flex flex-row items-center gap-2 sm:gap-3 w-full sm:w-auto shrink-0",
        className
      )}
    >
      <div
        className={cn(
          "w-[125px] xs:w-[140px] sm:w-[145px] lg:w-[170px] shrink-0",
          dropdownClassName
        )}
      >
        <CustomDropdown
          options={options}
          value={selectedValue}
          onChange={onCategoryChange}
          placeholder={placeholder}
          ariaLabel={dropdownAriaLabel}
        />
      </div>

      <div
        className={cn(
          "relative flex-1 min-w-0 sm:w-[200px] md:w-[220px] lg:w-[320px] xl:w-[380px]",
          searchClassName
        )}
      >
        <FaMagnifyingGlass className="absolute left-2.5 sm:left-3.5 top-1/2 -translate-y-1/2 w-3 h-3 sm:w-3.5 sm:h-3.5 text-white pointer-events-none" />
        <input
          type="text"
          placeholder={searchPlaceholder}
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full bg-black border border-white rounded-none pl-7 sm:pl-9 pr-2.5 sm:pr-4 py-2 font-poppins text-xs sm:text-sm text-white placeholder-white/60 focus:outline-none focus:ring-0 focus:border-white transition-colors"
        />
      </div>
    </div>
  );
}
